/**
 * ÄR TELEFONEN UPPKOPPLAD JUST NU?
 *
 * BESLUT 02: rösten ingår men BARA ONLINE — tolkningen sker på servern
 * (VOICE_TRANSCRIBE), så knappen ska vara AV utan nät i stället för att spela in
 * något som aldrig kan tolkas. <Rostknapp> i ui/Knapp.tsx tar `online` som prop
 * och förväntar sig alltså att skärmen vet svaret.
 *
 * ALLT ANNAT I APPEN FUNGERAR OFFLINE (beslut 12), så den här kroken får ALDRIG
 * användas för att stänga av sparandet. Den styr röstknappen och ingenting mer.
 *
 * KROKEN HÖR EGENTLIGEN HEMMA I src/app/ tillsammans med session och läge — se
 * LUCKOR. Den ligger här för att inte röra en gemensam fil.
 */

import { useSyncExternalStore } from 'react';

const prenumerera = (lyssnare: () => void): (() => void) => {
  globalThis.addEventListener('online', lyssnare);
  globalThis.addEventListener('offline', lyssnare);
  return () => {
    globalThis.removeEventListener('online', lyssnare);
    globalThis.removeEventListener('offline', lyssnare);
  };
};

// navigator.onLine säger BARA att ett nätgränssnitt finns, aldrig att servern
// svarar. Falskt positivt är ofarligt här: knappen blir klickbar och anropet
// faller på ett nätfel med sin egen text.
const las = (): boolean => globalThis.navigator?.onLine ?? true;

export const useOnline = (): boolean => useSyncExternalStore(prenumerera, las, () => true);
